import {
  Component,
  ElementRef,
  Injector,
  OnInit,
  ViewChild,
} from '@angular/core';
import { ToastrService } from 'ngx-toastr';
import { of, Subject, Subscription } from 'rxjs';
import { SettingsService } from '../settings/settings.service';
import { TranslateService } from '@ngx-translate/core';
import { RagService } from './rag.service';
import {
  debounceTime,
  distinctUntilChanged,
  switchMap,
  takeUntil,
} from 'rxjs/operators';
import { SocketService } from '../socket.service';
import { ThemePalette } from '@angular/material/core';
import { LegacyProgressBarMode as ProgressBarMode } from '@angular/material/legacy-progress-bar';
import { HomeService } from '../home.service';
declare let Swal: any;
interface SearchTerm {
  skip: number;
  limit: number;
  type: string;
  search: string;
}
@Component({
  selector: 'app-rag-v3',
  templateUrl: './rag-v3.component.html',
  styleUrls: ['./rag-v3.component.scss'],
})
export class RagV3Component implements OnInit {
  isLoading = null;
  loadershow = false;
  selectedRAGTab = null;
  selectedFile1: any = '';
  uploadLoader = false;
  uploadedFile = false;
  userSubscription1: Subscription;
  userSubscription2: Subscription;
  userSubscription3: Subscription;
  documentUrl: any;
  uploadCheck = false;
  private searchSubject = new Subject<SearchTerm>();
  private destroy$ = new Subject<void>();
  urlName = '';
  uploadUrlLoader = false;
  uploadUrlFile = false;
  uploadUrlCheck = false;
  projectId: any;
  allFiles: any;
  deleteFlag = false;
  istraining: any;
  selectedTab = 'All';
  selectedIndex = 0;
  color: ThemePalette = 'primary';
  mode: ProgressBarMode = 'buffer';
  value = 50;
  bufferValue = 40;
  lang = 'lang';
  @ViewChild('fileInput') fileInput: ElementRef;
  rag: any = {
    ragEnabled: '',
  };
  ragEnabled = false;
  toastr: ToastrService;
  _settingsService: SettingsService;
  translate: TranslateService;
  screenWidth: number;
  selectedRAGTabData: any;
  selectedRAGTabDataID: any;
  isReadMore = true;
  datalength = 5;
  totalCount = 60;
  page = 1;
  paginationDisabled = false;
  selectedFileData: any;
  searchRag: any;
  socket: SocketService;
  app_id: string;
  filterConfig1: any = {
    search: false,
    height: 'auto',
    placeholder: 'Select',
    customComparator: () => {
      // Do Nothing
    },
  };
  translate_text: any;
  supportLanguage: any;
  languageList: any = [];
  language = '';
  default_language = 'en';
  defaultLanguage: any;
  supportLanguagelength: any;
  arabic_lan;
  homeService: HomeService;
  dateFormat: string;
  constructor(
    private readonly injector: Injector,
    public readonly ragService: RagService,
  ) {
    this.toastr = this.injector.get<ToastrService>(ToastrService);
    this._settingsService = this.injector.get<SettingsService>(SettingsService);
    this.translate = this.injector.get<TranslateService>(TranslateService);
    this.homeService = this.injector.get<HomeService>(HomeService);
    this.translate.setDefaultLang('en');
    this.socket = this.injector.get<SocketService>(SocketService);
  }
  ngOnInit() {
    this.callLanguageSelectorAPI();
    this.app_id = JSON.parse(localStorage.getItem('user'))?.appid ?? '';
    this.socket.updateRagStatus().subscribe((message) => {
      console.log('updateRagStatus --->', message.appid, this.app_id);
      if (message.appid === this.app_id) {
        const args = {
          limit: 10,
          skip: this.page * 10 - 10,
          type: this.selectedTab,
          search: this.searchRag,
          language: this.language,
        };
        this.listAllUrlFiles(args);
      }
    });
    this.searchSubject
      .pipe(
        debounceTime(300),
        distinctUntilChanged(),
        switchMap((term) => (term ? this.ragService.listRags(term) : of([]))),
        takeUntil(this.destroy$),
      )
      .subscribe((res) => {
        console.log('search result', res);
        this.totalCount = res.totalCount ?? 0;
        this.allFiles = res?.info;
        this.DetailedView(this.allFiles[0]);
      });
      this.dateFormat = JSON.parse(localStorage.getItem('user'))?.dateFormat ?? 'MM/dd/YYYY';
  }

  callLanguageSelectorAPI() {
    this.ragService.languageSelector().subscribe(
      (data) => {
        if (data.status === 200) {
          this.handleLanguageSelectorResponse(data);
        }
      },
      (err) => {
        // Do Nothing
      },
    );
  }

  handleLanguageSelectorResponse(data) {
    if (data.support_language === 'no') {
      this.translate_text = 'no';
    } else {
      this.handleSupportLanguageElsecase(data);
    }
    const arg = {
      limit: 10,
      skip: this.page * 10 - 10,
      type: this.selectedTab,
      language: this.language,
    };
    this.listAllUrlFiles(arg);
  }

  handleSupportLanguageElsecase(data) {
    this.translate_text = 'yes';
    const lang = data.info.default_language;
    this.supportLanguage = data.info.supported_languages;
    if (this.supportLanguage?.length) {
      this.languageList = this.supportLanguage.map((elem) => {
        return elem.toUpperCase();
      });
      if (this.supportLanguage.includes(lang)) {
        this.language = lang;
      } else {
        this.language = this.supportLanguage[0];
      }
    } else {
      this.language = data.info.default_language;
    }
    this.default_language = lang.toUpperCase();
    this.defaultLanguage = data.info.default_language;
    this.filterConfig1.noResultsFound = this.default_language.toUpperCase();
    this.updateLanguageHelper();
    const keys = Object.keys(this.supportLanguage);
    this.supportLanguagelength = keys.length;
    if (this.supportLanguagelength === '1') {
      this.translate_text = 'no';
    }
  }

  updateLanguageHelper() {
    if (this.language === 'ar') {
      this.arabic_lan = true;
    } else {
      this.arabic_lan = false;
    }
  }
  languageselection(language: string) {
    localStorage.setItem(this.lang, language);
    this.language = language;
    this.page = 1;
    if (language === 'en') {
      // this.countryflg = 'assets/img/app/fl_gb.gif';
      this.arabic_lan = false;
    } else if (language === 'ar') {
      // this.countryflg = 'assets/img/app/ae-AE.gif';
      this.arabic_lan = true;
    } else {
      this.arabic_lan = false;
    }

    this.homeService.sendMessage({
      type: 'language',
      message: language,
    });
    const args = {
      limit: 10,
      skip: this.page * 10 - 10,
      type: this.selectedTab,
      search: this.searchRag,
      language: this.language,
    };
    this.listAllUrlFiles(args);
  }
  selectedRAGChange(value) {
    this.DetailedView(null);
    this.selectedRAGTab = value || null;
  }
  DetailedView(value) {
    if (value) {
      this.selectedRAGChange(null);
      this.selectedRAGTabData = value;
      this.selectedRAGTabDataID = value._id;
    } else {
      this.selectedRAGTabData = [];
      this.selectedRAGTabDataID = null;
    }
  }
  RediredctToNewTab(url: any) {
    window.open(url, '_blank');
  }
  CancelDocumentUpload() {
    this.selectedFile1 = '';
    this.uploadedFile = false;
    this.fileInput.nativeElement.value = '';
    this.uploadLoader = false;
    this.uploadedFile = false;
    this.selectedFile1 = '';
    this.selectedFileData = null;
    this.emptyFileInput();
    this.selectedRAGTab = null;
    this.DetailedView(this.allFiles[0]);
  }
  cancelWebsiteUpload() {
    this.urlName = '';
    this.selectedIndex = 0;
    this.uploadUrlFile = true;
    this.uploadUrlCheck = true;
    this.uploadLoader = false;
    this.uploadUrlLoader = false;
    this.uploadedFile = false;
    this.selectedFile1 = '';
    this.selectedFileData = null;
    this.emptyFileInput();
    this.selectedRAGTab = null;
    this.DetailedView(this.allFiles[0]);
  }
  pageChanged(page) {
    this.page = page;
    const args = {
      limit: 10,
      skip: this.page * 10 - 10,
      type: this.selectedTab,
      search: this.searchRag,
      language: this.language,
    };
    this.listAllUrlFiles(args);
  }

  matTableChange(e) {
    const labels = ['All', 'document', 'website'];
    this.selectedTab = labels[e.index] ?? 'All';
    const args = {
      limit: 10,
      skip: this.page * 10 - 10,
      type: e.index === 1 ? 'document' : e.index === 2 ? 'website' : 'All',
      search: this.searchRag,
      language: this.language,
    };
    this.listAllUrlFiles(args);
  }

  handleFileUpload(event: any): void {
    this.selectedFile1 = event.target.files[0];
    const reader1 = new FileReader();
    reader1.readAsBinaryString(this.selectedFile1);
    reader1.onload = async (onloadEvent: any) => {
      const Data = onloadEvent.target.result;
      const pageCount = Data.match(/\/Type\s*\/Page\b/g)?.length;
      if (pageCount > 250) {
        this.toastr.error('page count is above 250');
        this.selectedFile1 = '';
      } else if (
        event?.target?.files?.length &&
        event.target.files[0].type !== 'application/pdf'
      ) {
        this.selectedFile1 = '';
        this.toastr.error('Please upload valid pdf document');
      } else if (this.selectedFile1.size > 31457280) {
        this.selectedFile1 = '';
        this.toastr.error('Maximum file size must be less than 30MB');
        this.fileInput.nativeElement.value = '';
      } else {
        this.uploadedFile = true;
        this.selectedFileData = event;
      }
    };
  }

  uploadFile() {
    if (this.deleteFlag) {
      return;
    }
    if (!this.selectedFileData) {
      this.toastr.error('Please upload valid pdf document');
      return;
    }
    if (this.selectedTab !== 'document') {
      this.selectedTab = 'All';
    }
    this.uploadLoader = true;
    const appUser = JSON.parse(localStorage.getItem('user'));
    const Editfiles = this.selectedFileData.target.files;
    const file = Editfiles[0];
    const file2 = Editfiles[0]?.name;
    const pattern = /pdf-*/;
    const reader = new FileReader();
    reader.readAsBinaryString(file);
    reader.onload = async (onloadEvent: any) => {
      const Data = onloadEvent.target.result;
      const contentData = btoa(Data);
      const args = {
        data: contentData,
        contentType: file.type,
        filename: file2,
        appId: appUser.appid,
        type: 'document',
        language: this.language,
      };
      this.deleteFlag = true;
      this.userSubscription1 = this._settingsService.getFiles(args).subscribe(
        (res) => {
          this.deleteFlag = false;
          if (res) {
            this.selectedFile1 = '';
            this.uploadLoader = false;
            const arg = {
              limit: 10,
              skip: this.page * 10 - 10,
              type: this.selectedTab,
              language: this.language,
            };
            if (this.selectedTab === 'All') {
              this.selectedIndex = 0;
            }
            this.listAllUrlFiles(arg);
            this.documentUrl = res.info.documentUrl;
            this.uploadedFile = true;
            this.uploadCheck = true;
            this.selectedFileData = null;
            this.emptyFileInput();
            if (res.info.status === 400) {
              this.toastr.error(res.info.info);
            } else {
              this.toastr.success('Document uploaded successfully');
            }
          }

          if (!file.type.match(pattern)) {
            this.toastr.error(
              '',
              this.translate.instant('toastr.invalid_format'),
            );
            return false;
          }
          this.uploadLoader = false;
        },
        (error) => {
          this.deleteFlag = false;
          this.uploadLoader = false;
          if (error.status === 500) {
            this.toastr.error(
              '',
              this.translate.instant('toastr.error_msg_delete'),
            );
          } else {
            this.toastr.error('An error occurred during file upload.');
          }
          this.uploadLoader = false;
          this.selectedFile1 = '';
          this.selectedFileData = null;
        },
      );
    };
  }

  train() {
    if (this.deleteFlag) {
      return;
    }
    if (this.selectedTab !== 'website') {
      this.selectedTab = 'All';
    }
    if (this.urlName) {
      const urlRegex = /^(https?:\/\/|www\.)[^ "]+$/;
      if (urlRegex.test(this.urlName)) {
        this.uploadUrlLoader = true;
        const appUser = JSON.parse(localStorage.getItem('user'));
        const args = {
          data: this.urlName,
          contentType: 'text',
          filename: this.urlName,
          appId: appUser.appid,
          type: 'website',
          language: this.language,
        };
        this.deleteFlag = true;
        this.userSubscription2 = this._settingsService
          .getFiles(args)
          .subscribe((res) => {
            this.deleteFlag = false;
            if (res) {
              if (res.info.connectionStatus === 200) {
                this.urlName = '';
                this.documentUrl = res.info.documentUrl;
                this.uploadUrlCheck = true;
                this.toastr.success('Url uploaded successfully');
              } else if (res.info.connectionStatus === 500) {
                this.toastr.error(
                  '',
                  this.translate.instant('toastr.error_msg_delete'),
                );
              } else {
                if (res.info.status === 400) {
                  this.toastr.error(res.info.info);
                } else {
                  this.toastr.error('Url already trained');
                }
              }
              console.log('this.selectedTab', this.selectedTab);
              if (this.selectedTab === 'All') {
                this.selectedIndex = 0;
              }
              const arg = {
                limit: 10,
                skip: this.page * 10 - 10,
                type: this.selectedTab,
                language: this.language,
              };
              this.listAllUrlFiles(arg);
              this.urlName = '';
              this.uploadUrlLoader = false;
            } else {
              this.uploadUrlLoader = true;
            }
          });
      } else {
        this.urlName = '';
        this.deleteFlag = false;
        this.uploadUrlLoader = false;
        this.toastr.error('Invalid URL');
      }
    }
  }

  onKey(event: any) {
    this.urlName = event.target.value;
  }
  listAllUrlFiles(args) {
    this.loadershow = true;
    this.userSubscription3 = this.ragService.listRags(args).subscribe((res) => {
      if (res?.info) {
        this.totalCount = res.totalCount ?? 0;
        this.allFiles = res?.info;
        this.DetailedView(this.allFiles[0]);
      }
      this.loadershow = false;
    });
  }

  deleteRagDocument(ragDocumentId: string, item: any) {
    const args = {
      ragDocumentId: ragDocumentId,
    };
    this.deleteFlag = true;
    this.isLoading = ragDocumentId;
    this._settingsService.deleteRagDocument(args).subscribe((response) => {
      this.deleteFlag = false;
      this.isLoading = null;
      if (response.connectionStatus === 200) {
        if (item.trainingStatus === true) {
          this.toastr.success(
            '',
            this.translate.instant('toastr.deleted_document'),
          );
        } else {
          this.toastr.success(
            '',
            this.translate.instant('toastr.error_delete_file'),
          );
        }
      } else {
        this.toastr.error(
          '',
          this.translate.instant('toastr.error_msg_delete'),
        );
      }
      const arg = {
        limit: 10,
        skip: this.page * 10 - 10,
        type: this.selectedTab,
        language: this.language,
      };
      this.listAllUrlFiles(arg);
    });
  }
  emptyFileInput() {
    if (this.fileInput?.nativeElement) {
      this.fileInput.nativeElement.value = '';
    }
  }

  openConfirmationDialog(ragDocumentId: string, item: any) {
    if (this.deleteFlag || this.istraining) {
      return;
    }
    Swal.fire({
      title:
        '<i class="fa fa-exclamation-triangle" style="color:red" aria-hidden="true"></i>&nbsp; Are you sure you want to delete this?',
      showCancelButton: true,
      customClass: 'swal-wide',
      confirmButtonColor: '#333333',
    }).then((result) => {
      if (result.value) {
        this.deleteRagDocument(ragDocumentId, item);
      }
    });
  }
  searchRagList(term: any) {
    const args = {
      skip: this.page * 10 - 10,
      limit: 10,
      type: this.selectedTab,
      search: this.searchRag,
      language: this.language,
    };
    this.searchSubject.next(args);
  }
}
